import React from 'react'
import PropTypes from 'prop-types'
import { intl } from 'lang/intl'

import Toggle from '../../../../components/inputs/Toggle'
import { WebinarPanelComponent } from '../index'
import { useUpdateQuestionMode } from '../../../../../global/blocs/useLiveData'

import './WebinarSidebarQuestionsPanelComponent.scss'

const WebinarSidebarQuestionsPanelComponent = ({
  children,
  isQuestionsEnabled,
  isShowingPermissionToggle,
}) => {
  const updateQuestionMode = useUpdateQuestionMode()

  const toggleLabel = intl.formatMessage({
    defaultMessage: 'Audience can ask questions',
  })

  return (
    <>
      {isShowingPermissionToggle && (
        <WebinarPanelComponent>
          <div className="questions-mode-toggle-wrapper">
            <span>{toggleLabel}</span>
            <Toggle
              onChange={updateQuestionMode}
              toggled={isQuestionsEnabled}
              ariaLabel={toggleLabel}
            />
          </div>
        </WebinarPanelComponent>
      )}
      <div className="questions-wrapper">{children}</div>
    </>
  )
}

WebinarSidebarQuestionsPanelComponent.propTypes = {
  isQuestionsEnabled: PropTypes.bool,
  children: PropTypes.node,
  isShowingPermissionToggle: PropTypes.bool,
}

WebinarSidebarQuestionsPanelComponent.defaultProps = {
  isShowingPermissionToggle: false,
}

export default WebinarSidebarQuestionsPanelComponent
